import { useCompanyPosition } from 'hooks/useCompanyPosition'
import { useMemo } from 'react'
import { isDrivingPosition } from '../../drivingPosition'

export function useIsDrivingPosition(positionId: number) {
  const position = useCompanyPosition(positionId)
  const isPositionDriving = useMemo(
    () => isDrivingPosition(position),
    [position]
  )

  return isPositionDriving
}
